var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home-page",attrs:{"data-cy":"home"}},[(_vm.loaded)?_c('span',{staticClass:"labelCenter labelLogo"},[_c('span',{staticClass:"brand-logo"})]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }